import api from '../../../connections/api';
import routes_api from '../../../connections/routes_api';

// ##### CALENDARS

// GET CALENDARS
export const getCalendars = async () => {
  const response = await api.get(routes_api.planner_calendars);
  return response.data;
};

// CREATE CALENDAR
export const createCalendar = async (data) => {
  try {
    const response = await api.post(routes_api.planner_calendars, data);
    return response.data;
  } catch (error) {
    console.error('Failed to create calendar:', error.response?.data || error.message);
    throw error;
  }
};

// UPDATE CALENDAR
export const updateCalendar = async (id, data) => {
  try {
    const response = await api.patch(`${routes_api.planner_calendars}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update calendar:', error.response?.data || error.message);
    throw error;
  }
};

// DELETE CALENDAR
export const deleteCalendar = async (id) => {
  try {
    await api.delete(`${routes_api.planner_calendars}${id}/`);
  } catch (error) {
    console.error('Failed to delete calendar:', error.response?.data || error.message);
    throw error;
  }
};

// ##### EVENTS

// GET EVENTS
export const getEvents = async () => {
  const response = await api.get(routes_api.planner_events);
  const body = response.data;
  if (body && typeof body === 'object' && Array.isArray(body.results)) {
    return {
      results: body.results,
      window: body.window ?? null,
    };
  }
  return {
    results: Array.isArray(body) ? body : [],
    window: null,
  };
};

// CREATE EVENT
export const createEvent = async (data) => {
  try {
    const response = await api.post(routes_api.planner_events, data);
    return response.data;
  } catch (error) {
    console.error('Failed to create event:', error.response?.data || error.message);
    throw error;
  }
};

// UPDATE EVENT
export const updateEvent = async (id, data) => {
  try {
    const response = await api.patch(`${routes_api.planner_events}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update event:', error.response?.data || error.message);
    throw error;
  }
};

// DELETE EVENT
export const deleteEvent = async (id) => {
  try {
    await api.delete(`${routes_api.planner_events}${id}/`);
  } catch (error) {
    console.error('Failed to delete event:', error.response?.data || error.message);
    throw error;
  }
};
